// extracted by mini-css-extract-plugin
export default {"reportManagement":"ReportManagement_reportManagement__Adbus","contentTitle":"ReportManagement_contentTitle__ESpLY"};